import { EVENT_NAMES } from "./eventNames";

type EventTrackingConfig = {
  /** trueのとき、useTrackingContextStore の source をイベント名サフィックスに使用する */
  useSource?: boolean;
  /** trueのとき、useTrackingContextStore の pointsConsumed を props に含める */
  usePointsConsumed?: boolean;
  /** trueのとき、useTrackingContextStore の amountJpy（購入円額）をイベント名サフィックスに使用する */
  useAmountJpy?: boolean;
  /** デモ通話経由のアトリビューションを判定する対象（video: `_AFTER_DEMO_CALL`、consume: `CONSUME_POINT_AFTER_DEMO_CALL`） */
  demoAttribution?: ("video" | "consume")[];
  /** trueのとき、高評価ユーザー紹介オンボーディング経由の通話到達アトリビューションを判定し、対象なら COMPLETE_HIGH_REVIEW_ONBOARDING_TO_CALL を追加送信する */
  highReviewOnboardingAttribution?: boolean;
};

/**
 * イベントごとのトラッキングコンテキスト使用設定。
 * ここに定義されたイベントのみ、useTrackingContextStore の値を参照する。
 * 参照後はストアが自動でクリアされる（単一消費）。
 */
export const EVENT_TRACKING_CONFIG: Partial<
  Record<string, EventTrackingConfig>
> = {
  [EVENT_NAMES.COMPLETE_SEND_GIFT]: {
    useSource: true,
    usePointsConsumed: true,
    demoAttribution: ["consume"],
  },
  // さがす画面のLIVEカード経由で入室した場合のみ _FROM_DISCOVER サフィックスを追加送信する
  [EVENT_NAMES.WATCH_VIDEO_CHAT_AS_FIRST_VIEWER]: {
    useSource: true,
    demoAttribution: ["consume"],
  },
  [EVENT_NAMES.WATCH_VIDEO_CHAT_AS_VIEWER]: {
    useSource: true,
    demoAttribution: ["consume"],
  },
  [EVENT_NAMES.START_VIDEO_CALL]: {
    demoAttribution: ["video", "consume"],
    highReviewOnboardingAttribution: true,
  },
  [EVENT_NAMES.START_VOICE_CALL]: {
    demoAttribution: ["consume"],
    highReviewOnboardingAttribution: true,
  },
  [EVENT_NAMES.PURCHASE]: {
    demoAttribution: ["consume"],
  },
  [EVENT_NAMES.COMPLETE_BUY_IMAGE]: {
    demoAttribution: ["consume"],
  },
  [EVENT_NAMES.COMPLETE_BUY_VIDEO]: {
    demoAttribution: ["consume"],
  },
  [EVENT_NAMES.COMPLETE_BUY_AUDIO]: {
    demoAttribution: ["consume"],
  },
  [EVENT_NAMES.SEND_GIFT_IN_VIDEO_CALL]: {
    demoAttribution: ["consume"],
  },
  [EVENT_NAMES.SEND_GIFT_IN_VIDEO_CHAT]: {
    demoAttribution: ["consume"],
  },
  [EVENT_NAMES.COMPLETE_SEND_STAMP]: {
    demoAttribution: ["consume"],
  },
  [EVENT_NAMES.COMPLETE_SEND_MESSAGE]: {
    demoAttribution: ["consume"],
  },
  [EVENT_NAMES.SEND_LOVENSE_IN_VIDEO_CALL]: {
    demoAttribution: ["consume"],
  },
  [EVENT_NAMES.SEND_LOVENSE_IN_VIDEO_CHAT]: {
    demoAttribution: ["consume"],
  },
  [EVENT_NAMES.SEND_LOVENSE_FROM_QUICK_MENU]: {
    demoAttribution: ["consume"],
  },
  [EVENT_NAMES.SEND_VIDEO_COMPLETE_LOVENSE]: {
    demoAttribution: ["consume"],
  },
  [EVENT_NAMES.SEND_VIDEOCHAT_COMPLETE_LOVENSE]: {
    demoAttribution: ["consume"],
  },
  // 課金モーダル別の購入完了イベント。金額別集計用に円額サフィックス版を追加送信する
  [EVENT_NAMES.PURCHASE_FROM_POINT_SHORTAGE_MODAL]: {
    useAmountJpy: true,
  },
  [EVENT_NAMES.PURCHASE_FROM_LIVE_CHARGE_MODAL]: {
    useAmountJpy: true,
  },
  [EVENT_NAMES.PURCHASE_FROM_CALL_CHARGE_MODAL]: {
    useAmountJpy: true,
  },
};
